import { type FC, type ReactNode } from "react";

import { Button } from "@/shared/components/ui/button";

import wateringGraphic from "@/shared/assets/illustrations/watering.svg";

import { LegalAuthoritySidebar } from "./LegalAuthoritySidebar";

interface LegalAuthorityInfoStepProps {
  onBack: () => void;
  onContinue: () => void;
  children: ReactNode;
}

export const LegalAuthorityInfoStep: FC<LegalAuthorityInfoStepProps> = ({
  onBack,
  onContinue,
  children,
}) => (
  <div className="flex h-full">
    <LegalAuthoritySidebar activeStep={2} />

    <div className="flex min-w-0 flex-1 flex-col bg-subtle">
      <div className="flex min-h-0 flex-1 flex-col items-center justify-center gap-4 overflow-y-auto p-4 sm:px-16 sm:py-6">
        <img
          src={wateringGraphic}
          alt="Plant being watered"
          className="h-[180px] w-[180px] object-contain"
        />
        <h4 className="text-center">That's okay</h4>
        <div className="flex max-w-[500px] flex-col gap-3 text-sm text-secondary">{children}</div>
      </div>

      <div className="flex shrink-0 items-center justify-between border-t border-primary px-4 py-4 sm:px-6">
        <Button variant="outline" size="md" onClick={onBack}>
          Back
        </Button>
        <Button variant="brand" size="md" onClick={onContinue}>
          Continue
        </Button>
      </div>
    </div>
  </div>
);
